 <template src="./template.html" ></template>

<script>
// @ is an alias to /src
import myAxios from '../../functions/myAxios'
import MyListTable from './Table.vue'
// import MyPrintTable from './PrintTable.vue'
import MyBalance from './MyBalance.vue'
import MyPersons from '../../components/MyPersons.vue'
import MyBankaccounts from '../../components/MyBankaccounts.vue'
import MyBoxes from '../../components/MyBoxes.vue'
import MyProducts from '../../components/MyProducts.vue'
import MyBillRange from './MyBillRange.vue'
import MyDate from '../../components/MyDate.vue'
import {
  toJalaali,
} from '../../functions/myDate'
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  name: 'BillView',
  methods: {
    getRequestParams(person_id, bank_account_id, box_id, product_id, range, date, page, pageCount) {
      let params = {}

      if (person_id) {
        params["mid"] = person_id
      }

      if (bank_account_id) {
        params["mid"] = bank_account_id
      }

      if (box_id) {
        params["mid"] = box_id
      }

      if (product_id) {
        params["mid"] = product_id
      }

      if (range) {
        params["range"] = range
      }

      if (range === "dateRange" && date) {
        params["date"] = date
      }

      if (page) {
        params["page"] = page - 1
      }

      if (pageCount) {
        params["size"] = pageCount
      }

      return params
    },
    async getBalance() {
      if (this.route === 'persons' && !this.person_id) return
      if (this.route === 'bank_accounts' && !this.bank_account_id) return
      if (this.route === 'boxes' && !this.box_id) return
      if (this.route === 'products' && !this.product_id) return
      //
      let _mid = null
      if (this.route === 'persons') _mid = this.person_id
      if (this.route === 'boxes') _mid = this.box_id
      if (this.route === 'bank_accounts') _mid = this.bank_account_id
      if (this.route === 'products') _mid = this.product_id
      try {
        let type;
        if (this.billType === 'bill') {
          type = 'balance'
        } else if (this.billType === 'lendingBill') {
          type = 'lendingBalance'
        }
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}/${type}`,
          params: {
            mid: _mid
          }
        });
        if (res && res.data) {
          // console.log(res.data);
          this.balance = res.data.balance
          if (type === 'lendingBalance') {
            this.product = res.data.product[0]
            // this.balance = `${doubleDisplay(res.data.balance)} ${res.data.product[0].unit1} = ${doubleDisplay(res.data.balance / res.data.product[0].n)} ${res.data.product[0].unit2}`
          } else {
            // this.balance = res.data.balance
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    async retrieveData() {
      if (this.route === 'persons' && !this.person_id) return
      if (this.route === 'bank_accounts' && !this.bank_account_id) return
      if (this.route === 'boxes' && !this.box_id) return
      if (this.route === 'products' && !this.product_id) return
      const query = this.getRequestParams(
        this.person_id,
        this.bank_account_id,
        this.box_id,
        this.product_id,
        this.range,
        this.date,
        this.page,
        this.pageCount,
      );
      //
      // console.log(query);
      try {
        this.loading = true
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}/${this.billType}`,
          params: query
        });
        if (res && res.data && res.data.data && res.data.page) {
          // if (this.billType === 'bill') {
          //   this.data = await this.setDataForTable(res.data.data)
          // } else {
          this.data = res.data.data
          // }
          // console.log(this.data);
          this.totalPages = Math.ceil(Number(res.data.count) / this.pageCount)
          if (this.page != res.data.page) {
            this.page = res.data.page
          }
        } else {
          this.data = []
          this.totalPages = 0
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async retrievePrintData() {
      if (this.route === 'persons' && !this.person_id) return
      if (this.route === 'boxes' && !this.box_id) return
      if (this.route === 'bank_accounts' && !this.bank_account_id) return
      if (this.route === 'products' && !this.product_id) return
      const query = this.getRequestParams(
        this.person_id,
        this.bank_account_id,
        this.box_id,
        this.product_id,
        this.range,
        this.date,
      );
      //
      // console.log(query);
      try {
        // this.loading = true
        this.printData = []
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}/${this.billType}`,
          params: query
        })
        if (res && res.data && res.data.data) {
          this.printData = res.data.data
          //
          // let perChunk = 19 // items per chunk
          // this.printData = res.data.data.reduce((resultArray, item, index) => {
          //
          //   const chunkIndex = Math.floor(index / perChunk)
          //
          //   if (!resultArray[chunkIndex]) {
          //     resultArray[chunkIndex] = [] // start a new chunk
          //   }
          //   resultArray[chunkIndex].push(item)
          //
          //   return resultArray
          // }, [])
          //
          let name = await myAxios({
            method: 'GET',
            url: `/api/persons`,
            params: {
              mid: this.person_id
            }
          });
          if (name && name.data) {
            this.name = `${name.data.last_name || ''} ${name.data.first_name}`
            // this.name = `${name.data.last_name} ${name.data.first_name}`
          }
          // this.printData = await this.setDataForTable(res.data.data)
        }
      } catch (e) {
        console.error(e)
      } finally {
        // this.loading = false
      }
    },
    debounceSearch() {
      clearTimeout(this.debounce)
      //
      this.debounce = setTimeout(() => {
        // if (this.searchItem.name === 'create_date') {
        //   if (!isValidJalaaliDate(this.searchText)) {
        //     return;
        //   }
        // }
        // this.loading = true
        this.page = 1
        this.retrieveData()
      }, 1000)
    },
    async setFromDateValue(item) {
      this.date.from = item
    },
    async setToDateValue(item) {
      this.date.to = item
    },
    handlePageChange(value) {
      if (Number(this.$router.currentRoute.params.PageNum) !== Number(value)) {
        let url = `/${this.route}/${this.billType}/${value}`
        this.$router.push({
          path: url
        }) // -> /banks/page/123
        this.retrieveData()
      }
    },
    handlePageCountChange(size) {
      this.pageCount = size;
      this.page = 1;
      this.retrieveData();
    },
    onChangeType(e) {
      if (e === 'bill') {
        this.headers = this.$store.getters.pageInfo.bill
      } else if (e === 'lendingBill') {
        this.headers = this.$store.getters.pageInfo.lendingBill
      }
      this.retrieveData();
    },
    back() {
      this.$router.push(`/`)
    },
    async print() {
      await this.retrievePrintData()
      if (!this.printData.length) return
      this.showPrintTable = true
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open();
      // <p style="text-align: center">صورت حساب</p>
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            <br/>
            <div style="margin: 20px">
            ${prtHtml}
            </div>
            <br/>
          </body>
        </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => {
        WinPrint.print();
        WinPrint.close();
      }, 500)
      // this.print = true
      // setTimeout(() => {
      //   window.print()
      // }, 100)
      this.showPrintTable = false
    },
  },
  async created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    this.headers = this.$store.getters.pageInfo.bill
    //
    let page = this.$router.currentRoute.path.split("/")[3]
    // alert(page);
    this.page = Number(page)
  },
  mounted() {
    this.date.from = toJalaali(new Date()).date
    this.date.to = toJalaali(new Date()).date
  },
  data: () => ({
    tooltip: true,
    loading: false,
    data: [],
    name: '', //for print
    printData: [],
    showPrintTable: false,
    totalPages: 0,
    pageCount: 15,
    itemsPerPage: [15, 25, 50],
    person_id: null,
    bank_account_id: null,
    box_id: null,
    product_id: null,
    balance: 0,
    product: null,
    billType: 'bill',
    range: '30',
    date: {
      from: null,
      to: null,
    },
  }),
  components: {
    VueJsonToCsv,
    MyListTable,
    // MyPrintTable,
    MyBalance,
    MyPersons,
    MyBankaccounts,
    MyBoxes,
    MyProducts,
    MyBillRange,
    MyDate,
  },
}
</script>
